
import Vue from 'vue'
import {
    lembrarDadosAcesso,
    limparDadosAcesso,
    obterDadosAcesso,
} from "@/core/utils/auth.util";
import { AUTH_REQUEST } from '@/store/actions/action';

export default Vue.extend({
    name: 'AcessarContaComponent',
    data() {
        return {
            loading: false,
            model: {
                email: '',
                senha: '',
                lembrarAcesso: false
            }
        }
    },
    computed: {
        desabilitarBtnLogin(): boolean {
            return this.model.email === '' || this.model.senha === '';
        },
        isMobile() {
            return this.$vuetify.breakpoint.mobile;
        }
    },
    methods: {
        aoFazerLogin() {
            if (!this.desabilitarBtnLogin) {
                this.loading = true;
                this.$store
                    .dispatch(AUTH_REQUEST, this.model)
                    .then((result) => {
                        const message = result.messages[0];
                        if (result.success) {
                            if (
                                this.model.lembrarAcesso &&
                                this.model.email !== "" &&
                                this.model.senha !== ""
                            ) {
                                lembrarDadosAcesso(this.model);
                            }
                            this.loading = false;

                            const returnUrl = this.$route.query['returnUrl'] as string;

                            const url = returnUrl ? returnUrl : "/"
                            this.$router.push({
                                path: url,
                            });
                        } else {
                            this.$toast.error(message.text);
                            // this.renovarCaptcha = true;
                        }
                    })
                    .catch((error) => {
                        // this.renovarCaptcha = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        aoMarcarLembrarAcesso() {
            if (this.model.lembrarAcesso) {
                lembrarDadosAcesso(this.model);
            } else {
                limparDadosAcesso();
            }
        },
        aoMudarPasso(step: number) {
            this.$emit(`step`, step);
        },
        setUserFromLocalStorage() {
            const usuario = obterDadosAcesso();

            if (usuario) {
                this.model = usuario;
            }
        },
    },
    created() {
        this.setUserFromLocalStorage();
    }
})
